import React, { useEffect, useState } from "react";
import {
  ShareurlWithImg,
  Toast,
  Userlogin,
  formatRupee,
  formateNumberStNdRd,
  handleGetApiGF,
  handlePostApiGF,
} from "../Utils/general-function";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import RemainingPageTitle from "../Utils/RemainingPageTitle";
import NoCars from "../Utils/NoCars";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollButton from "../Utils/scrollbutton";
import { FaShareAltSquare } from "react-icons/fa";
import { FiShare2 } from "react-icons/fi";
// advance filter
import blackheart from "../../src_img/blackheart.png";
import redheart from "../../src_img/redheart.png";

function CustomerCarWishlists() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [allFavCars, setAllFavCars] = useState([]);

  const fetchAllFavCars = async () => {
    const res = await handleGetApiGF({
      url: "/api/DealerFavouriteVehicle/AllFavouritecars",
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Something went wrong!");
      setLoading(false);
      return;
    }
    setAllFavCars(res?.data?.Data || []);
    setLoading(false);
  };

  const removeCarWishlist = async (data) => {
    setLoading(true);
    const { carnumber, carid } = data || {};
    console.log("carid", carid);

    // actiondata(Add/Delete)
    let obj = {
      actiondata: "Delete",
      carnumber,
      carid,
    };
    const res = await handlePostApiGF({
      url: "/api/DealerFavouriteVehicle/addfavouritecars",
      obj,
    });
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Something went wrong");
      setLoading(false);
      return;
    }
    await fetchAllFavCars();
    Toast(
      res?.succ,
      res?.msg || "Successful",
      res?.msg || "Something went wrong",
    );

    console.log("res add remove wishlist", res);
  };
  useEffect(() => {
    fetchAllFavCars();
  }, []);
  console.log("allFavCars", allFavCars);

  return (
    <div>
      <Header />
      <div className="text-center d-flex align-items-center justify-content-center page-space">
        <h2 className="page-title mb-0 p-0 text-center">Wishlisted Car</h2>
        {/* <div
          className="d-flex align-items-center gap-2 justify-content-center"
          style={{
            border: "1px solid red",
            borderRadius: "6px",
            padding: "5px 5px",
            color: "red",
            fontWeight: "500",
            fontSize: "16px",
          }}
        >
          <FiShare2 size={20} /> Share All
        </div> */}
      </div>

      <div className="page-space pt-0" style={{ marginBottom: "50px" }}>
        {loading && <Loader />}
        {allFavCars.length === 0 && !loading ? (
          <>
            <NoCars
              mainMsg=""
              msg="Your wishlist is empty. Start adding your favorite cars!"
            />
            <div className="w-100 text-center">
              <Link to={"/customercarlist"} className="submitbtn">
                See All Cars
              </Link>
            </div>
          </>
        ) : (
          allFavCars.map((data, i) => (
            <div className="car-div mt-4" key={data.Rand}>
              <div className="car-radius">
                <div className="position-relative">
                  <img
                    src={redheart}
                    style={{ position: "absolute", right: "10px", top: "10px" }}
                    alt=""
                    onClick={() => removeCarWishlist(data)}
                  />
                  <div
                    style={{
                      position: "absolute",
                      right: "11px",
                      top: "50px",
                      backgroundColor: "aliceblue",
                      padding: "4px",
                      borderRadius: "100%",
                      color: "red",
                      height: "30px",
                      width: "30px",
                    }}
                  >
                    <FiShare2
                      size={20}
                      style={{ position: "relative", top: "-2px" }}
                      onClick={(e) => {
                        let url = new URL(
                          `/#/customercardetail/${data?.Rand}`,
                          window.location.origin,
                        ).href;
                        ShareurlWithImg({
                          url,
                          text: `${data?.modelyear} ${data?.companyid} ${data?.carmodelid} ${data?.variantid}`,
                        });
                      }}
                    />
                  </div>
                  <img src={data.carphoto} className="w-100" alt="" />
                </div>
                <div className="car-smdetails">
                  <span className="abs-span">{data.fueltypeid}</span>
                  <RemainingPageTitle dataFromParent={data} />

                  <div className="car-km justify-content-start gap-2 flex-wrap">
                    <>
                      <div className="d-flex align-items-center">
                        <img src="assets/images/car-num.svg" alt="" />
                        <span>{data.carnumber}</span>
                      </div>
                      {data.km && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/car-km.svg"
                            alt=""
                            // className="ms-2"
                          />
                          <span>
                            {formatRupee({ amt: data.km, rupeeIcon: false })}
                          </span>
                        </div>
                      )}
                      {/* {data.Carage && (
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 357.102 357.102"
                            // className="ms-2"
                          >
                            <g>
                              <path
                                d="M192.349 13.8c-90.484 0-164.387 73.614-164.741 164.096..."
                                fill="#ff002a"
                              ></path>
                              <path
                                d="M186.553 98.752c-8.284 0-15 6.716-15 15v63..."
                                fill="#ff002a"
                              ></path>
                            </g>
                          </svg>
                          <span>{data.Carage} days</span>
                        </div>
                      )} */}

                      {data?.clientprofilelist[0]?.nCity && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/address.png"
                            height={21}
                            width={21}
                            alt="address"
                            // className="ms-2"
                          />
                          <span>
                            {data?.clientprofilelist[0]?.nCity},{" "}
                            {data?.clientprofilelist[0]?.nState}
                          </span>
                        </div>
                      )}
                    </>
                  </div>
                </div>
                <div className="two-btns">
                  <Link
                    to={`/customercardetail/${data?.Rand}`}
                    state={{ details: data }}
                    className="w-100 lightRedBtn"
                    style={{ borderRadius: "0 0 10px 10px" }}
                  >
                    More Details
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}

        {/* <InfiniteScroll
          dataLength={resultsContxt.length}
          next={loadMoreCars}
          hasMore={hasMore}
          // loader={<Loader />}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
        /> */}

        <ScrollButton />
      </div>
    </div>
  );
}

export default CustomerCarWishlists;
